import { render, staticRenderFns } from "./bannerLogin.vue?vue&type=template&id=f0728fb6&scoped=true"
import script from "./bannerLogin.vue?vue&type=script&lang=js"
export * from "./bannerLogin.vue?vue&type=script&lang=js"
import style0 from "./bannerLogin.vue?vue&type=style&index=0&id=f0728fb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0728fb6",
  null
  
)

export default component.exports